export default function PopUp() {
	const popupDiv = document.createElement('div');
	popupDiv.id = 'block-popup-is-popup';
	popupDiv.className = 'block-popup-is-popup';
	document.body.appendChild(popupDiv);

	const content = document.getElementById('block-popup-is-content').innerHTML;
	document.getElementById('block-popup-is-popup').innerHTML = content;
	document.body.classList.add('popup-visible');

	// Click event on the close button inside the popup
	popupDiv.addEventListener('click', (event) => {
		// Check if the clicked element is the close button
		if (event.target.classList.contains('close-button')) {
			// Hide the popup
			popupDiv.style.display = 'none';

			// Remove 'popup-visible' class from the body
			document.body.classList.remove('popup-visible');
		}
	});
}
